export default {
  biometricsSchema: (state, getters) => {
    if (state.biometricsSchema) {
      return state.biometricsSchema
    } else {
      return null
    }
  },
  biometricsEntered: (state, getters) => {
    return state.biometricsEntered
  },
  codeSent: (state, getters) => {
    return state.codeSent
  },
  getFormData: (state, getters) => {
    return state.formData
  },
  multiTextValues: (state, getters) => {
    return state.multiTextValues
  },
  multiTextVals: (state, getters) => {
    return state.multiTextVals
  },
  signUpSchema: (state, getters) => {
    if (state.signUpSchema) {
      return state.signUpSchema
    } else {
      return null
    }
  },
  signedUp: (state, getters) => {
    return state.signedUp
  },
  verificationSchema: (state, getters) => {
    if (state.verificationSchema) {
      return state.verificationSchema
    } else {
      return null
    }
  },
  verified: (state, getters) => {
    return state.verified
  },
  resendCodeSchema: (state, getters) => {
    if (state.resendCodeSchema) {
      return state.resendCodeSchema
    } else {
      return null
    }
  },
  verifyError: (state, getters) => {
    return state.verifyError
  }
}



// WEBPACK FOOTER //
// ./src/app/store/signup/getters.js